//矩形框 
import makerjs from "makerjs";
function Rectangle(inputParam, model,fixedParam,zoom){
var plate=model.plate,markers=model.markers,cutPlate=model.cutPlate,myZoom=zoom*1,
    glassW=inputParam.X,glassH=inputParam.Y,
   markShift=fixedParam.markShift*1,markShiftTwo=fixedParam.markShiftTwo*1,
   markShiftThree=fixedParam.markShiftThree*1,markShiftFour=fixedParam.markShiftFour*1,markHolesOneD=fixedParam.markHolesOneD*1,
   w = glassW * 1,
   TxtW= "长(X)="+w.toString(),
 h = glassH * 1,        
 TxtH=  "宽(Y)="+h.toString(); 
 
 console.log("**********=glassW",glassW);
if(w==h){
 var Rectangle = new makerjs.models.Square(w);
}else{
 var Rectangle = new makerjs.models.Rectangle(w, h);
}
plate = {
 models: {
  Rectangle:Rectangle
 },
};
cutPlate = {
 models: {
  Rectangle:Rectangle
 },
};
var myWidthMark = new makerjs.models.Square(0);
var myHeightMark = new makerjs.models.Square(0);

makerjs.model.addPath(myWidthMark, new makerjs.paths.Line([0, -markShift+markShift], [0, -markShift-markShift]));//长度左竖短标线
makerjs.model.addPath(myWidthMark, new makerjs.paths.Line([w, -markShift+markShift], [w, -markShift-markShift]));//长度右竖短标线
makerjs.model.addPath(myWidthMark, new makerjs.paths.Line([0, -markShift], [w, -markShift]));//长度标线
makerjs.model.addCaption(myWidthMark, TxtW, [0, -markShiftThree], [w, -markShiftThree]);//长度文字

makerjs.model.addPath(myHeightMark, new makerjs.paths.Line([-markShift+markShift,0], [-markShift-markShift, 0]));//宽度标线
makerjs.model.addPath(myHeightMark, new makerjs.paths.Line([-markShift+markShift,h], [-markShift-markShift, h]));//宽度标线
makerjs.model.addPath(myHeightMark, new makerjs.paths.Line([-markShift,0], [-markShift, h]));//宽度标线
makerjs.model.addCaption(myHeightMark, TxtH, [-markShiftThree,0], [-markShiftThree, h]);//宽度文字
markers={
models: {
myWidthMark: myWidthMark,
myHeightMark: myHeightMark,
Rectangle:Rectangle
  }
};
return{plate, cutPlate, markers}
};
export default Rectangle;